import React, { useRef, useEffect, useState } from 'react';
import { Button, Form, Icon, Input, Upload } from 'antd';
import AddPhotoAlternateOutlinedIcon from '@material-ui/icons/AddPhotoAlternateOutlined';
import styles from './ChatConversation.module.css';
import { sendAnalyticsEvent } from '../analytics';

const { TextArea } = Input;

const MessageInputField = ({
  sendMessage,
  loadingState,
  onMessageChange,
  newMessage,
  setSnackbar,
  conversation,
}) => {
  const messageInput = useRef(null);

  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    messageInput.current.focus();
  }, [loadingState, fileList]);

  useEffect(() => {
    setFileList([]);
  }, [conversation]);

  const uploadProps = {
    name: 'image',
    accept: 'image/*',
    fileList,
    className: 'upload-list-above',
    showUploadList: false,
    disabled: loadingState !== 'ready',
    beforeUpload(file) {
      setFileList([file]);
    },
    // dummy request to bypass making a POST request
    customRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess('ok');
      }, 0);
    },
    onChange(info) {
      if (info.file.status === 'error') {
        setSnackbar(`${info.file.name} file upload failed.`);
      }
    },
    onRemove() {
      setFileList([]);
    },
  };

  const sendImage = () => {
    if (fileList.length !== 0) {
      const formData = new FormData();
      const selectedImage = fileList[0];
      formData.append('image', selectedImage, selectedImage.name);
      conversation.sendMessage(
        {
          contentType: selectedImage.type,
          media: selectedImage,
        },
        { from_employee: true, source: 'admin_portal' },
      );
      setFileList([]);
      sendAnalyticsEvent('customMessageSent', {
        type: selectedImage.type,
      });
    }
  };

  const handleSubmit = (event) => {
    sendMessage(event);
    sendImage();
  };

  return (
    <>
      {!!fileList.length && (
        <div className={styles['upload-image-preview']}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <Icon
              type="picture"
              theme="twoTone"
              style={{ fontSize: '20px', margin: '5px 10px 5px 5px' }}
            />
            {fileList[0].name}
          </span>
          <Icon
            type="delete"
            className={styles['delete-icon']}
            onClick={uploadProps.onRemove}
          />
        </div>
      )}
      <Form onSubmit={handleSubmit} className={styles['new-message-form']}>
        <Upload className={styles['image-upload']} {...uploadProps}>
          <AddPhotoAlternateOutlinedIcon
            disabled={loadingState !== 'ready'}
            className={loadingState === 'ready' && 'clickable-icon'}
          />
        </Upload>
        <TextArea
          autoSize={{ minRows: 1, maxRows: 4 }}
          placeholder="Type your message here..."
          style={{ margin: '0 15px', borderRadius: '15px' }}
          disabled={loadingState !== 'ready'}
          onChange={onMessageChange}
          value={newMessage}
          onPressEnter={handleSubmit}
          ref={messageInput}
        />
        <Button
          type="primary"
          shape="round"
          htmlType="submit"
          disabled={loadingState !== 'ready'}
        >
          Send
        </Button>
      </Form>
    </>
  );
};

export default MessageInputField;
